import React, { useState, useEffect } from "react";

const ALL_OPTIONS = ["Emergency Loan", "Normal Loan", "Topup Loan"];

const ChooseLoanType = ({
  isChooseLoanTypeOpen,
  closeChooseLoanType,
  handleEligibilityCheck,
  loanOptions = ALL_OPTIONS,
}) => {
  const [selectedAccount, setSelectedAccount] = useState(loanOptions[0]);

  // Keep selected value in sync whenever the available options change
  useEffect(() => {
    if (loanOptions && loanOptions.length > 0) {
      setSelectedAccount(loanOptions[0]);
    }
  }, [loanOptions]);

  if (!isChooseLoanTypeOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50 p-4 backdrop-blur-sm overflow-y-auto">
      {/* Retained 750px max-width bounds with responsive viewport adjustments */}
      <div className="relative bg-white shadow-xl rounded-md w-full max-w-[750px] min-h-[420px] my-auto p-5 sm:p-8 flex flex-col justify-between transition-all">
        {/* Close Button */}
        <button
          onClick={closeChooseLoanType}
          className="absolute top-4 right-4 text-gray-500 hover:text-black text-xl font-bold p-1 leading-none"
          aria-label="Close modal"
        >
          ✕
        </button>

        {/* Header */}
        <div className="mt-2 pr-6">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2 break-words">
            Create Account
          </h2>
          <p className="text-gray-600 text-xs sm:text-sm">
            Choose the account you’d like to create for the member.
          </p>
        </div>

        {/* Form Controls - Centered & Safe Wrapping */}
        <div className="my-8 flex flex-col items-center justify-center w-full">
          <div className="flex flex-col items-start w-full max-w-[404px]">
            <label
              htmlFor="select-loan-type"
              className="text-base sm:text-lg font-semibold text-gray-900 mb-2"
            >
              Select Account
            </label>

            <div className="relative w-full">
              <select
                id="select-loan-type"
                className="block w-full bg-white border border-gray-300 rounded-md py-3 pl-4 pr-10 text-sm sm:text-base text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-500 cursor-pointer"
                value={selectedAccount}
                onChange={(e) => setSelectedAccount(e.target.value)}
              >
                {loanOptions?.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* Footer Action Button */}
        <div className="flex flex-col sm:flex-row justify-end pt-4 border-t border-gray-100">
          <button
            onClick={() => {
              handleEligibilityCheck(selectedAccount);
              if (loanOptions && loanOptions.length > 0) {
                setSelectedAccount(loanOptions[0]);
              }
            }}
            className="w-full sm:w-[238px] bg-[#074073] hover:bg-[#052f5a] text-white font-medium h-[48px] sm:h-[51px] px-6 rounded-md text-sm transition-colors duration-150"
          >
            Check Eligibility
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChooseLoanType;
